/* import __COLOCATED_TEMPLATE__ from './image-overlay.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();